export enum UserStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    New = 3,
    Purge = 4,
    Invited = 5
}